import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { connect } from 'react-redux';
import Link from 'next/link';
import { classnames } from '@@client/lib/classes';

var mapStateToProps = function mapStateToProps(_ref) {
  var chat = _ref.chat,
      config = _ref.config;
  return {
    chat: chat,
    config: config
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {};
};

var LinksContactUs = function LinksContactUs(_ref2) {
  var chat = _ref2.chat,
      config = _ref2.config,
      _ref2$linkClassName = _ref2.linkClassName,
      linkClassName = _ref2$linkClassName === void 0 ? null : _ref2$linkClassName,
      _ref2$chatButtonClass = _ref2.chatButtonClassName,
      chatButtonClassName = _ref2$chatButtonClass === void 0 ? null : _ref2$chatButtonClass;
  return /*#__PURE__*/_jsxs("ul", {
    children: [/*#__PURE__*/_jsx("li", {
      children: /*#__PURE__*/_jsx("a", {
        className: linkClassName,
        href: "tel:".concat(config.contact.phoneFull),
        children: config.contact.phoneHuman
      })
    }), chat.isAvailable ? /*#__PURE__*/_jsx("li", {
      children: /*#__PURE__*/_jsx("button", {
        className: classnames([chatButtonClassName, linkClassName]),
        children: "Live Chat"
      })
    }) : null, /*#__PURE__*/_jsx("li", {
      children: /*#__PURE__*/_jsx(Link, {
        href: "/contact",
        children: /*#__PURE__*/_jsx("a", {
          className: linkClassName,
          children: "Send Us a Message"
        })
      })
    }), /*#__PURE__*/_jsx("li", {
      children: /*#__PURE__*/_jsx(Link, {
        href: "/locations",
        children: /*#__PURE__*/_jsx("a", {
          className: linkClassName,
          children: "B&R Store Locations"
        })
      })
    })]
  });
};

var ExportLinksContactUs = connect(mapStateToProps, mapDispatchToProps)(LinksContactUs);
export default ExportLinksContactUs;